import { useQuery } from '@tanstack/react-query';

import { getRedDotApi } from '@flipster/apis/v1/red-dot';
import { useAuth } from '@flipster/features/src/shared/auth/state';

export const useRedDot = () => {
  const { isCookieLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['getRedDotApi'],
    queryFn: getRedDotApi,
    select: (res) => res.data,
    enabled: isCookieLoggedIn,
    refetchOnMount: true,
  });
};
